export const searchType: any = {
  flight: "Flight",
  hotel: "Hotel",
  dynamicPackage: "Flight+Hotel",
};
